import { render } from "./MonthlyBillingModal.vue?vue&type=template&id=1b4adc37&scoped=true"
import script from "./MonthlyBillingModal.vue?vue&type=script&lang=js"
export * from "./MonthlyBillingModal.vue?vue&type=script&lang=js"

import "./MonthlyBillingModal.vue?vue&type=style&index=0&id=1b4adc37&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4adc37"]])

export default __exports__